<ag-progress-list
  [requestObject]="requestObject"
  [disableDetailFullScreen]="true"
  [job]="job"
  [enableSeminarScheduleLinkButton]="true"
></ag-progress-list>
